import React, { useMemo, useContext, useCallback } from 'react';
import useLocalStorage from 'app/model/LocalStorage';
import { fixRedactedPhoneNumberForRTLText, toArabicNumber, toEnglishNumber, toPersianNumber } from 'app/home/general-components/NumberInputHelper';

import stringsData from './Strings';
import packageJson from '../../../package.json';

export const LocalizationContext = React.createContext(undefined);

export function LocalizationContextProvider(props) {
    const [fullLanguage, setFullLanguage] = useLocalStorage('appLanguage', packageJson.defaultLanguage || 'fa');
    const language = useMemo(() => {
        return fullLanguage.split("-")[0]
    }, [fullLanguage]);
    const strings = useMemo(() => {
        return stringsData[language];
    }, [language]);

    const isRTL = useMemo(() => (language !== 'en'), [language]);

    const localizeNumber = useCallback((ss) => {
        const s = String(ss);
        if (s) {
            if (language === 'en') {
                return toEnglishNumber(s, true);
            } else if (language === 'fa') {
                return toPersianNumber(s, true);
            } else if (language === 'ar') {
                return toArabicNumber(s, true);
            } else {
                return s;
            }
        } else {
            return s;
        }
    }, [language]);

    const localizeAndFixSignedNumbers = useCallback((ss) => {
        const s = String(ss);
        if (s) {
            if (language === 'en') {
                return toEnglishNumber(s, true);
            } else if (language === 'fa') {
                if (s.length > 0) {
                    if (s[0] === "+") {
                        return toPersianNumber(
                            fixRedactedPhoneNumberForRTLText(s.substring(1)), true) + "+";
                    } else if (s[0] === "-") {
                        return toPersianNumber(s.substring(1), true) + "-";
                    } else {
                        return toPersianNumber(s, true);
                    }
                } else {
                    return toPersianNumber(s, true);
                }
            } else if (language === 'ar') {
                if (s.length > 0) {
                    if (s[0] === "+") {
                        return toArabicNumber(
                            fixRedactedPhoneNumberForRTLText(s.substring(1)), true) + "+";
                    } else if (s[0] === "-") {
                        return toArabicNumber(s.substring(1), true) + "-";
                    } else {
                        return toArabicNumber(s, true);
                    }
                } else {
                    return toArabicNumber(s, true);
                }
            }
        } else {
            return s;
        }
    }, [language]);

    return (
        <LocalizationContext.Provider value={
            {
                strings, localizeNumber, localizeAndFixSignedNumbers,
                language, fullLanguage, setFullLanguage,
                isRTL,
            }}>
            {props.children}
        </LocalizationContext.Provider>
    )
}

export function useLocalizedStrings() {
    return useContext(LocalizationContext).strings;
}

// strings.setLanguage(this.state.language);
// strings.how